/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Tenant_AdminInputs */

const es_components_credentials_permissions_tenant_admin = /** @type {(inputs: Components_Credentials_Permissions_Tenant_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador del Tenant`)
};

const en_components_credentials_permissions_tenant_admin = /** @type {(inputs: Components_Credentials_Permissions_Tenant_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant Admin`)
};

/**
* | output |
* | --- |
* | "Tenant Admin" |
*
* @param {Components_Credentials_Permissions_Tenant_AdminInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_tenant_admin = /** @type {((inputs?: Components_Credentials_Permissions_Tenant_AdminInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Tenant_AdminInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_tenant_admin(inputs)
	return en_components_credentials_permissions_tenant_admin(inputs)
});
export { components_credentials_permissions_tenant_admin as "components.credentials.permissions.tenant_admin" }